import { Button, Form, Input, InputNumber, Select, Space, Typography } from 'antd';
import React, { useState } from 'react';
import './App.css';

const { Option } = Select;
const { Title } = Typography;
const formItemLayout = {
  labelCol: {
    span: 4
  },
  wrapperCol: {
    span: 18
  }
};

function App() {
  const [pingfang, setPingfang] = useState(0);
  const [lifang, setLifang] = useState(0);
  const [form] = Form.useForm();

  /**
   * 计算
   */
  const handleClick = (flag?: boolean) => {
    const values = form.getFieldsValue();
    const { gao = 0, kuan = 0, hou = 0, price = 0 } = values;
    if (flag) {
      const pf = (gao / 1000) * (kuan / 1000) * price
      setPingfang(parseFloat(pf.toFixed(2)));
      return;
    }
    const lf = (gao / 1000) * (kuan / 1000) * (hou / 1000) * price
    setLifang(parseFloat(lf.toFixed(2)));
  }

  return (
    <div className="App">
      <div className='container'>
        <Form form={form} name='form' {...formItemLayout} size='large' layout='horizontal'>
          <Form.Item
            name="Select1"
            label="选择颜色"
          >
            <Select placeholder="选择颜色" showSearch>
              <Option value="红色">红色</Option>
              <Option value="蓝色">蓝色</Option>
              <Option value="白色">白色</Option>
              <Option value="黑色">黑色</Option>
            </Select>
          </Form.Item>
          <Form.Item
            name="Select2"
            label="输入颜色"
          >
            <Input placeholder='输入颜色' />
          </Form.Item>
          <Form.Item
            name="gao"
            label="高(cm)"
          >
            <InputNumber placeholder="高" min={0} style={{ width: '100%' }} />
          </Form.Item>
          <Form.Item
            name="kuan"
            label="宽(cm)"
          >
            <InputNumber placeholder="宽" min={0} style={{ width: '100%' }} />
          </Form.Item>
          <Form.Item
            name="hou"
            label="厚(cm)"
          >
            <InputNumber placeholder="厚" min={0} style={{ width: '100%' }} />
          </Form.Item>
          <Form.Item
            name="price"
            label="价格"
          >
            <InputNumber placeholder="价格" min={0} style={{ width: '100%' }} />
          </Form.Item>
          <Space size={25}>
            <Button type="primary" onClick={() => handleClick(true)}>
              计算平方
            </Button>
            <Button type="primary" danger onClick={() => handleClick()}>
              计算立方
            </Button>
          </Space>
        </Form>
        <div>
          <Title level={4}>平方价格：{pingfang}平方/元</Title>
          <Title type="danger" level={4}>立方价格：{lifang}立方/元</Title>
        </div>
      </div>
    </div>
  );
}

export default App;
